import { Injectable, inject } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { withLatestFrom, switchMap, mergeMap, catchError, of } from "rxjs";
import { QuoteClient, QuoteSearchRequest } from "src/api-service";
import { selectSelectedCompany } from "../../../../user/user.selectors";
import { ReviewQuotesActions } from "./review-quotes.actions";

@Injectable()
export class ReviewQuotesEffects {
    private readonly actions$ = inject(Actions);
    private readonly store = inject(Store);
    private readonly quoteClient = inject(QuoteClient);

    load$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ReviewQuotesActions.load),
            withLatestFrom(this.store.select(selectSelectedCompany)),
            switchMap(([{ searchFilter, statuses, companyIds, pagination }, selectedCompany]) => {
                const request: QuoteSearchRequest = {
                    pageNumber: pagination?.pageIndex ?? 1,
                    pageSize: pagination?.pageSize ?? 100000000,
                    filter: searchFilter || undefined,
                    sortProperty: "version.readyForReviewDate",
                    sortAscending: false,
                    companyIds,
                    statuses,
                    toCentralSalesSupport: true,
                };

                return this.quoteClient
                    .getFilteredFromMultipleCompanies(
                        request,
                        selectedCompany.id,
                    )
                    .pipe(
                        mergeMap(response => [
                            ReviewQuotesActions.loadSuccess({
                                response: response.data,
                                pagination: response.pagination,
                                searchFilter,
                                statuses,
                            }),
                        ]),
                        catchError(error =>
                            of(
                                ReviewQuotesActions.loadFailure({
                                    error: error?.message || "Unknown error",
                                    toastKey: "SEARCH.TOAST.LOAD_ERROR",
                                }),
                            )
                        ),
                    );
            }),
        ),
    );
}
